import { useEffect, useState } from "react";
import { getUrlParam } from "../utils/helpers";
import VexEditor from "../components/VexEditor";

const Home = () => {
    return <VexEditor />;
}

export default Home;
